/* ===================================================== <keis-teaser>
   The teaser product page (sections/main-teaser.liquid).

   The ice: three canvases over the gallery stage.
     frostTex  the ice, painted once per size: a cold base, grain, crystals
               growing in from the edges, sparkle, and the prompt traced
               through it as if by a fingertip.
     mask      how much ice is left (alpha). Rubbing erases it with a soft
               brush; left alone it slowly frosts back over.
     drops     meltwater that runs down from a rub and clears a streak.
   Past ~55% thawed the rest melts on its own. On touch, a side-to-side rub
   thaws and an up-and-down swipe still scrolls the page (touch-action:
   pan-y), so the picture is never a scroll trap.

   The riddle: guesses are compared by fingerprint (SHA-256 of "keis:" + the
   guess, trimmed), so the answer is never in the page or in this file.
   ========================================================================= */
(function () {
  'use strict';

  /* The answer, in the shop's languages, as fingerprints only. */
  var ANSWERS = ['a81bae4b73efe543', '403517b9d89c7d45', '63d8571f4113836f', '1d517a0de6bf0fc5', 'a0f0f82b3b153b10',
    '1d75c850b4bdf347', 'babf1786656d829b', '4c0acc3f10ac416d', '383b2748d9aca129', 'd2a627025b297f78', 'c451f3de476c921e',
    'ab2a7323a7d2a1bc', 'b628cfccaa79784d', 'cdae95a04f0331c2', '8da4a3bf8b46c27c', '15f0f2b3ddf57381', '097af8c04decca4f',
    'f9f9e06d2c5b4efd', 'a50def43c9905a6a', 'b6efa16eaaf4703f', '3c055aa9ff0b61b7', '757ac45a78926f97'];

  /* Hot and cold for the wrong guesses: English words, the reply text from
     the page (so it translates). [pattern, warmth 0–1, reply attribute]. */
  var HINTS = [
    [/boot|shoe|insole|slipper/, .85, 'boot'],
    [/feet|foot|toe/, .8, 'foot'],
    [/glove|mitt|hand|liner/, .6, 'hand'],
    [/trouser|pant|leg|jean/, .6, 'leg'],
    [/jacket|vest|gilet|bodywarmer|shirt|top|coat/, .25, 'body'],
    [/hat|helmet|balaclava|neck|scarf|collar|head/, .08, 'head'],
    [/seat|cushion|grip|bar|bike/, .15, 'bike']
  ];

  function El() { return Reflect.construct(HTMLElement, [], El); }
  El.prototype = Object.create(HTMLElement.prototype);
  El.prototype.constructor = El;
  Object.setPrototypeOf(El, HTMLElement);

  El.prototype.connectedCallback = function () {
    this.ice();
    this.riddle();
    this.clues();
    this.dial();
  };

  /* ── The ice ──────────────────────────────────────────────────────── */
  El.prototype.ice = function () {
    var host = this, stage = this.querySelector('[data-teaser-stage]'), c = this.querySelector('[data-teaser-frost]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!stage || !c || !c.getContext || reduce) { host.classList.add('no-frost', 'is-thawed'); return; }

    var ctx = c.getContext('2d'), W = 0, H = 0, S = 1;
    var frostTex = document.createElement('canvas'), mask = document.createElement('canvas');
    var probe = document.createElement('canvas'); probe.width = 32; probe.height = 40;
    var pctx = probe.getContext('2d', { willReadFrequently: true });
    var drops = [], last = null, lastMove = 0, thawed = 0, done = false, raf = 0, frame = 0;
    var gauge = this.querySelector('[data-teaser-gauge]'), hint = this.querySelector('[data-teaser-hint]'), bloom = this.querySelector('[data-teaser-bloom]');
    var d = this.dataset, touch = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    if (touch && hint) hint.textContent = d.hintSwipe;

    function rand(a, b) { return a + Math.random() * (b - a); }
    function crystal(g, x, y, len, ang, depth, w) {
      if (depth <= 0 || len < 2) return;
      var x2 = x + Math.cos(ang) * len, y2 = y + Math.sin(ang) * len;
      g.lineWidth = w; g.beginPath(); g.moveTo(x, y); g.lineTo(x2, y2); g.stroke();
      var n = Math.floor(rand(2, 5));
      for (var i = 1; i <= n; i++) {
        var t = i / (n + 1), bx = x + (x2 - x) * t, by = y + (y2 - y) * t, bl = len * rand(.25, .45) * (1 - t * .5);
        crystal(g, bx, by, bl, ang + rand(.6, 1.1), depth - 1, w * .6);
        crystal(g, bx, by, bl, ang - rand(.6, 1.1), depth - 1, w * .6);
      }
      crystal(g, x2, y2, len * .55, ang + rand(-.25, .25), depth - 1, w * .7);
    }
    function paintFrost() {
      var g = frostTex.getContext('2d'); frostTex.width = W; frostTex.height = H;
      var base = g.createRadialGradient(W / 2, H * .5, Math.min(W, H) * .15, W / 2, H / 2, Math.max(W, H) * .75);
      base.addColorStop(0, 'rgba(196,214,226,.88)'); base.addColorStop(1, 'rgba(232,242,248,.97)');
      g.fillStyle = base; g.fillRect(0, 0, W, H);
      var img = g.getImageData(0, 0, W, H), px = img.data;
      for (var i = 0; i < px.length; i += 4) { var n = (Math.random() - .5) * 22; px[i] += n; px[i + 1] += n; px[i + 2] += n; }
      g.putImageData(img, 0, 0);
      g.strokeStyle = 'rgba(255,255,255,.55)'; g.lineCap = 'round';
      var edges = Math.round((W + H) / 34 / S * 1.2);
      for (var k = 0; k < edges; k++) {
        var side = k % 4, x, y, a;
        if (side === 0) { x = rand(0, W); y = 0; a = Math.PI / 2; } else if (side === 1) { x = W; y = rand(0, H); a = Math.PI; }
        else if (side === 2) { x = rand(0, W); y = H; a = -Math.PI / 2; } else { x = 0; y = rand(0, H); a = 0; }
        g.globalAlpha = rand(.35, .8); crystal(g, x, y, rand(36, 100) * S, a + rand(-.5, .5), 4, rand(1, 2) * S);
      }
      for (k = 0; k < 18; k++) { g.globalAlpha = rand(.15, .4); var fx = rand(0, W), fy = rand(0, H);
        for (var arm = 0; arm < 6; arm++) crystal(g, fx, fy, rand(8, 20) * S, arm * Math.PI / 3, 2, .8 * S); }
      g.globalAlpha = 1;
      for (k = 0; k < 200; k++) { g.fillStyle = 'rgba(255,255,255,' + rand(.3, .9) + ')'; g.fillRect(rand(0, W), rand(0, H), S * rand(.6, 1.6), S * rand(.6, 1.6)); }
      /* the prompt, traced by a fingertip */
      var word = (d.thawPrompt || 'Thaw me').toUpperCase(), fs = Math.min(W * .16, 110 * S);
      g.save(); g.translate(W / 2, H * .44); g.rotate(-.06);
      g.font = '900 italic ' + fs + 'px Montserrat, Arial, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle';
      while (g.measureText(word).width > W * .82 && fs > 12) { fs *= .92; g.font = '900 italic ' + fs + 'px Montserrat, Arial, sans-serif'; }
      g.globalCompositeOperation = 'destination-out'; g.globalAlpha = .55; g.lineJoin = 'round'; g.lineWidth = fs * .08; g.strokeText(word, 0, 0);
      g.globalCompositeOperation = 'source-over'; g.globalAlpha = .35; g.lineWidth = Math.max(1, fs * .012); g.strokeStyle = '#fff'; g.strokeText(word, 0, 0);
      g.restore();
    }
    function size() {
      var r = c.getBoundingClientRect();
      S = Math.min(1.5, window.devicePixelRatio || 1);
      var w = Math.round(r.width * S), h = Math.round(r.height * S);
      if (!w || !h || (w === W && h === H)) return;
      var copy = null;
      if (W) { copy = document.createElement('canvas'); copy.width = W; copy.height = H; copy.getContext('2d').drawImage(mask, 0, 0); }
      W = c.width = mask.width = w; H = c.height = mask.height = h;
      var m = mask.getContext('2d'); m.fillStyle = '#000'; m.fillRect(0, 0, W, H);
      if (copy) { m.globalCompositeOperation = 'copy'; m.drawImage(copy, 0, 0, W, H); m.globalCompositeOperation = 'source-over'; }
      paintFrost(); kick();
    }
    function erase(x, y, r, a) {
      var m = mask.getContext('2d'); m.globalCompositeOperation = 'destination-out';
      var g = m.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, 'rgba(0,0,0,' + a + ')'); g.addColorStop(.6, 'rgba(0,0,0,' + a * .55 + ')'); g.addColorStop(1, 'rgba(0,0,0,0)');
      m.fillStyle = g; m.beginPath(); m.arc(x, y, r, 0, 7); m.fill(); m.globalCompositeOperation = 'source-over';
    }
    function rubTo(cx, cy) {
      var r = c.getBoundingClientRect(), x = (cx - r.left) * S, y = (cy - r.top) * S;
      if (bloom) bloom.style.transform = 'translate(' + (cx - r.left) + 'px,' + (cy - r.top) + 'px)';
      host.classList.add('is-rubbing'); lastMove = performance.now();
      if (done) return;
      var R = Math.max(34, Math.min(W, H) * .09);
      if (last) {
        var dx = x - last.x, dy = y - last.y, dist = Math.hypot(dx, dy), steps = Math.ceil(dist / (R * .3));
        for (var i = 1; i <= steps; i++) erase(last.x + dx * i / steps, last.y + dy * i / steps, R, .5);
        if (dist > 6 * S && Math.random() < .35 && drops.length < 50) drops.push({ x: x + rand(-R, R) * .6, y: y + R * .4, r: rand(2.2, 4.5) * S, v: rand(.4, 1.1) * S, life: rand(120, 220) });
      } else erase(x, y, R, .5);
      last = { x: x, y: y }; kick();
    }
    function measure() {
      pctx.clearRect(0, 0, 32, 40); pctx.drawImage(mask, 0, 0, 32, 40);
      var px = pctx.getImageData(0, 0, 32, 40).data, left = 0;
      for (var i = 3; i < px.length; i += 4) left += px[i];
      thawed = 1 - left / (255 * 32 * 40);
      var pct = Math.min(1, thawed / .55);
      if (gauge) gauge.style.width = (pct * 100).toFixed(0) + '%';
      if (hint && !done && thawed > .02) hint.textContent = pct < .4 ? (touch ? d.hintSwipe : d.hintRub) : pct < .8 ? d.hintWarmer : pct < 1 ? d.hintNearly : d.hintDone;
      if (thawed >= .55 && !done) finish();
    }
    function finish() {
      done = true;
      for (var k = 0; k < 30; k++) drops.push({ x: rand(0, W), y: rand(0, H * .6), r: rand(2, 5) * S, v: rand(.8, 2) * S, life: rand(80, 150) });
      setTimeout(function () { host.classList.add('is-thawed'); }, 250);
    }
    function draw() {
      raf = 0; frame++;
      var now = performance.now();
      if (now - lastMove > 160) { host.classList.remove('is-rubbing'); last = null; }
      if (!done && now - lastMove > 1400 && thawed > .02) {
        var m = mask.getContext('2d'); m.globalAlpha = .006; m.fillStyle = '#000'; m.fillRect(0, 0, W, H); m.globalAlpha = 1;
      }
      for (var i = drops.length - 1; i >= 0; i--) {
        var p = drops[i]; p.v = Math.min(p.v * 1.012 + .01 * S, 3.2 * S); p.y += p.v; p.life--;
        erase(p.x, p.y, p.r * 1.6, .22);
        if (p.life <= 0 || p.y > H + 10) drops.splice(i, 1);
      }
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over'; ctx.drawImage(frostTex, 0, 0);
      ctx.globalCompositeOperation = 'destination-in'; ctx.drawImage(mask, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      for (i = 0; i < drops.length; i++) {
        var q = drops[i], g = ctx.createRadialGradient(q.x - q.r * .3, q.y - q.r * .35, 0, q.x, q.y, q.r);
        g.addColorStop(0, 'rgba(255,255,255,.85)'); g.addColorStop(.35, 'rgba(210,230,245,.35)'); g.addColorStop(1, 'rgba(40,60,80,.35)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(q.x, q.y, q.r, q.r * 1.25, 0, 0, 7); ctx.fill();
      }
      if (frame % 8 === 0) measure();
      if (!(done && !drops.length) && (drops.length || now - lastMove < 1600 || (!done && thawed > .02))) kick();
    }
    function kick() { if (!raf) raf = requestAnimationFrame(draw); }

    c.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' || e.buttons || e.pointerType === 'pen') rubTo(e.clientX, e.clientY); });
    c.addEventListener('touchstart', function (e) { var t = e.touches[0]; last = null; rubTo(t.clientX, t.clientY); }, { passive: true });
    c.addEventListener('touchmove', function (e) { var t = e.touches[0]; rubTo(t.clientX, t.clientY); }, { passive: true });
    var skip = this.querySelector('[data-teaser-skip]');
    if (skip) skip.addEventListener('click', function () {
      var k = 0, t = setInterval(function () {
        for (var j = 0; j < 6; j++) erase(rand(0, W), rand(0, H), Math.min(W, H) * .25, .7);
        lastMove = performance.now(); kick(); if (++k > 30) { clearInterval(t); if (!done) finish(); }
      }, 40);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { W = 0; size(); }); else size();
    window.addEventListener('resize', size);
  };

  /* ── The riddle ───────────────────────────────────────────────────── */
  function fingerprint(s) {
    if (!window.crypto || !crypto.subtle || !window.TextEncoder) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode('keis:' + s)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join('').slice(0, 16);
    });
  }
  El.prototype.riddle = function () {
    var host = this, form = this.querySelector('[data-teaser-guess]');
    if (!form) return;
    var input = form.querySelector('input'), reply = form.querySelector('[data-teaser-reply]'), needle = form.querySelector('[data-teaser-needle]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var raw = input.value.trim().toLowerCase();
      if (!raw) return;
      var plain = raw.normalize ? raw.normalize('NFD').replace(/[̀-ͯ]/g, '') : raw;
      plain = plain.replace(/[^a-z\s]/g, '').trim();
      var key = plain.replace(/^(heated|beheizte?|heizbare?|chauffantes?|calefactad[oa]s?|verwarmde?|riscaldat[ei])\s+/, '').replace(/\s+/g, '');
      input.value = '';
      Promise.all([fingerprint(key), fingerprint(raw.replace(/\s+/g, ''))]).then(function (fps) {
        reply.className = 'keis-teaser__reply';
        if (ANSWERS.indexOf(fps[0]) !== -1 || ANSWERS.indexOf(fps[1]) !== -1) {
          reply.classList.add('is-hot'); if (needle) needle.style.left = '100%';
          reply.textContent = form.dataset.right;
          var banner = host.querySelector('[data-teaser-solved]');
          if (banner) banner.hidden = false;
          var email = host.querySelector('#TeaserEmail');
          setTimeout(function () {
            var box = host.querySelector('#teaser-notify');
            if (box && box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
            if (email) email.focus({ preventScroll: true });
          }, 900);
          return;
        }
        var h = null;
        for (var i = 0; i < HINTS.length; i++) if (HINTS[i][0].test(plain)) { h = HINTS[i]; break; }
        var heat = h ? h[1] : .1;
        if (needle) needle.style.left = (heat * 100) + '%';
        reply.classList.add(heat >= .5 ? 'is-warm' : 'is-cold');
        reply.textContent = (h && form.dataset[h[2]]) || form.dataset.wrong;
      });
    });
  };

  /* ── Clues, one at a time ─────────────────────────────────────────── */
  El.prototype.clues = function () {
    var list = [].slice.call(this.querySelectorAll('.keis-teaser__clue'));
    list.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (b.disabled || b.classList.contains('is-open')) return;
        b.classList.add('is-open');
        b.querySelector('.keis-teaser__clue-state').textContent = '';
        var next = list[i + 1];
        if (next) { next.disabled = false; next.querySelector('.keis-teaser__clue-state').textContent = next.dataset.reveal; }
      });
    });
  };

  /* ── The heat dial ────────────────────────────────────────────────── */
  El.prototype.dial = function () {
    var btns = [].slice.call(this.querySelectorAll('[data-teaser-level]')), glows = [].slice.call(this.querySelectorAll('[data-teaser-glow]'));
    function set(n) {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.teaserLevel) === n)); });
      /* Evenly from off to full, however many settings the page lists. */
      var top = Math.max(1, btns.length - 1);
      glows.forEach(function (g) { g.style.opacity = n / top; });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { set(Number(b.dataset.teaserLevel)); }); });
    set(1);
  };

  if (!customElements.get('keis-teaser')) customElements.define('keis-teaser', El);
})();
